module.exports = __webpack_public_path__ + "img/5-1.a12836d4.png";